import $ from "jquery";
import Opentip from "opentip";
window.$ = $;
window.jQuery = $;
window.Opentip = Opentip;
